import { CrmSearchErrorEmptyState, BaseCrmSearchError } from 'crm-object-search-query-utilities';
import { useEffect } from 'react';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useError } from './useError';
import { BoardError, captureException, createBoardError } from './utils';
import { PipelineNotFoundError } from 'crm-object-board-core/pipeline';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const checkForCrmSearchError = e => BaseCrmSearchError.isCrmSearchError(e);
export const ErrorState = ({
  children
}) => {
  const error = useError();
  useEffect(() => {
    if (error) {
      //presume board errors are already logged
      if (error instanceof BoardError) {
        return;
      }
      const boardError = createBoardError(error.message, error);
      //try to capture more details about search errors
      if (BaseCrmSearchError.isCrmSearchError(error)) {
        captureException(boardError, error, {
          extra: {
            metadata: error.metadata,
            isCrmSearchError: true
          }
        });
      } else if (error instanceof Error) {
        //Duplicate errors/causes are not logged
        captureException(boardError, error);
      }
    }
  }, [error]);
  if (!error) {
    return children;
  }
  const isCrmSearchError = checkForCrmSearchError(error);
  const isPipelineNotFoundError = error instanceof PipelineNotFoundError;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isCrmSearchError && /*#__PURE__*/_jsx("div", {
      "data-test-id": "crm-search-utils-error",
      children: /*#__PURE__*/_jsx(CrmSearchErrorEmptyState, {
        error: error
      })
    }), isPipelineNotFoundError && /*#__PURE__*/_jsx(ErrorMessage, {
      type: "badRequest",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "crmObjectBoard.error.pipelineNotFound"
      }),
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoard.error.message"
        })
      })
    }), !isCrmSearchError && !isPipelineNotFoundError && /*#__PURE__*/_jsx(ErrorMessage, {
      type: "badRequest",
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoard.error.unknown"
        })
      })
    })]
  });
};